import Vue from 'vue'
import Router from 'vue-router'

import Home from './Home/layout/Home.vue'
import NotFound from './Home/layout/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    if (to.hash) {
      const element: any = document.querySelector(to.hash);
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        });
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/help',
    //   name: 'help',
    //   component: () => import(/* webpackChunkName: "help" */ './Help/layout/Help.vue')
    // },
    { path: '*', component: NotFound }
  ]
})

export default router
